<div data-testid="view-entries-container" class="title-search-container">
  <goab-text data-testid="view-entries-title" tag="h1" size="heading-l" mb="m">
    {{ 'headerTitle' | res : pageId }}
  </goab-text>
</div>

<goab-tabs (onChange)="onTabChange($event)" [initialTab]="1">
  <goab-tab heading="To-do reports" data-testid="todo-tab">
    @if(userFacilities().length) {
    <ng-container
      *ngTemplateOutlet="
        tableTmpl;
        context: { facilities: userFacilities(), tab: 'todo' }
      "
    ></ng-container>
    } @else {
    <app-no-reports-found></app-no-reports-found>
    }
  </goab-tab>
  <goab-tab heading="Completed reports" data-testid="completed-tab">
    @if(userFacilities().length) {
    <ng-container
      *ngTemplateOutlet="
        tableTmpl;
        context: { facilities: userFacilities(), tab: 'completed' }
      "
    ></ng-container>
    } @else {
    <app-no-reports-found></app-no-reports-found>
    }
  </goab-tab>
</goab-tabs>

<ng-template #tableTmpl let-facilities="facilities" let-tab="tab">
  <goab-table
    [attr.data-testid]="'entries-table-' + tab"
    width="100%"
    (onSort)="tableOnSort($event)"
  >
    <thead>
      <tr>
        <th>
          <goab-table-sort-header
            [name]="'facilityName'"
            [direction]="sort().facilityName!"
          >
            <div class="header-container">
              <span> {{ 'col1Label' | res : pageId }}</span>
            </div>
          </goab-table-sort-header>
        </th>
        <th>
          <goab-table-sort-header
            [name]="'capacityReportPeriodDueDate'"
            [direction]="sort().capacityReportPeriodDueDate!"
          >
            <div class="header-container">
              <span> {{ 'col2Label' | res : pageId }}</span>
            </div>
          </goab-table-sort-header>
        </th>
        <th>
          <goab-table-sort-header
            [name]="'submittedAt'"
            [direction]="sort().submittedAt!"
          >
            <div class="header-container">
              <span> {{ 'col3Label' | res : pageId }}</span>
            </div>
          </goab-table-sort-header>
        </th>

        <th>{{ 'col4Label' | res : pageId }}</th>
        <th>{{ 'col5Label' | res : pageId }}</th>
      </tr>
    </thead>
    <tbody class="view-entries-table">
      <tr
        *ngFor="let facility of facilities; index as i"
        [ngClass]="i % 2 === 0 ? 'even' : 'odd'"
      >
        <td>
          <!--TODO: link to facility details page -->

          <a
            *ngIf="
              !facility.hasEarlierIncompleteReports ||
                facility.status === 'Completed';
              else labelOnly
            "
            routerLink=""
            (click)="
              onFacilityClick(
                facility.id,
                facility.facilityName,
                facility.status
              )
            "
          >
            {{ facility.facilityName }}
          </a>
          <ng-template #labelOnly>
            <span class="locked-label">{{ facility.facilityName }}</span>
            <span class="locked-label"
              >Locked: Please submit the previous week's report to unlock this
              report</span
            ></ng-template
          >
        </td>
        <td>
          @if(!facility.hasEarlierIncompleteReports || facility.status ===
          'Completed'){
          {{ facility.capacityReportPeriodDueDate | alaDateTransform }}
          } @else {
          <span class="locked-label">
            {{ facility.capacityReportPeriodDueDate | alaDateTransform }}</span
          >
          }
        </td>

        @if(facility.submittedAt && facility?.status === 'Completed' ) {
        <td>{{ facility.submittedAt | alaDateTransform }}</td>
        } @else {
        <td>-</td>
        }

        <td>
          <goab-badge
            data-testid="status-badge"
            [type]="facility.status | badgeTransform"
            content="{{ facility.status | alaEnumReverseMapping }}"
          ></goab-badge>
        </td>
        @if(facility.submittedAt && facility?.status === 'Completed' ) {
        <td>{{ facility.submittedByName }}</td>
        } @else {
        <td>-</td>
        }
        <!-- <td>{{ facility.submittedByName }}</td> -->
      </tr>
    </tbody>
  </goab-table>
</ng-template>

<div data-testid="entries-table-container" class="table-container">
  @if(facilitiesCount() > 0) {
  <div data-testid="pagination-container" class="pagination-container">
    <div class="per-page-selector" data-testid="per-page-selector" mb="m">
      <span>Show</span>
      <goab-dropdown
        data-testid="per-page-dropdown"
        (onChange)="handlePerPageCountChangeEvent($event)"
        [value]="perPageCount().toString()"
        width="9ch"
        size="compact"
      >
        <goab-dropdown-item
          *ngFor="let option of perPageCountOptions()"
          [value]="option.toString()"
          [label]="option.toString()"
        ></goab-dropdown-item>
      </goab-dropdown>

      <span data-testid="total-entries-count" class="entries-count"
        >of {{ facilitiesCount() }}</span
      >
    </div>

    <goab-pagination
      data-testid="pagination-selector"
      [itemCount]="facilitiesCount()"
      [perPageCount]="perPageCount()"
      [pageNumber]="page()"
      (onChange)="handlePageChange($event)"
    ></goab-pagination>
  </div>
  }
</div>

<goab-drawer
  #drawer
  testid="facility-display-drawer"
  [heading]="drawerHeaderTmplInstance"
  position="right"
  (onClose)="onDrawerClose()"
  [open]="isDrawerOpen()"
  maxSize="60vw"
>
  <router-outlet></router-outlet>
</goab-drawer>
<ng-template
  #drawerHeaderTmpl
  let-selectedFacilityName="selectedFacilityName"
  let-selectedFacilityStatus="selectedFacilityStatus"
  let-dataEntry="dataEntry"
>
  <div class="drawHeaderContainer">
    <goab-text
      class="heading"
      data-testid="data-entry-title"
      size="heading-l"
      tag="h1"
      mt="none"
      mb="none"
    >
      {{ selectedFacilityName }}
    </goab-text>
    <goab-badge
      class="status-badge"
      data-testid="status-badge"
      [type]="selectedFacilityStatus | badgeTransform"
      content="{{ selectedFacilityStatus | alaEnumReverseMapping }}"
    ></goab-badge>
  </div>
</ng-template>
<ng-template #drawerHeaderTmplInstance>
  <ng-container
    *ngTemplateOutlet="
      drawerHeaderTmpl;
      context: {
        selectedFacilityName: selectedFacilityName,
        selectedFacilityStatus: selectedFacilityStatus,
        dataEntry: dataEntry
      }
    "
  ></ng-container>
</ng-template>
